var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPaycheckIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.4944 14.0327C18.0757 14.4437 17.8364 15.0351 17.8962 15.6666C17.9859 16.7492 18.973 17.5411 20.0499 17.5411H21.9443V18.734C21.9443 20.809 20.2592 21.5006 18.1953 21.5006H6.74898C4.68505 21.5006 3 20.809 3 18.734V11.9878C3 9.91282 4.68505 8.21875 6.74898 8.21875H18.1953C20.2592 8.21875 21.9443 9.91282 21.9443 11.9878V13.4313H19.9302C19.3719 13.4313 18.8634 13.6518 18.4944 14.0327Z",
    stroke: "#344266",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3 12.8893V8.30839C3 7.11553 3.72786 6.05293 4.83461 5.63192L12.7513 2.62471C13.9877 2.15357 15.3138 3.07582 15.3138 4.40902V8.21814",
    stroke: "#344266",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9998 14.4521V16.5171C22.9998 17.0684 22.5611 17.5195 22.0028 17.5395H20.0485C18.9717 17.5395 17.9846 16.7476 17.8948 15.665C17.835 15.0335 18.0743 14.4421 18.4931 14.0311C18.862 13.6502 19.3705 13.4297 19.9289 13.4297H22.0028C22.5611 13.4497 22.9998 13.9008 22.9998 14.4521Z",
    stroke: "#344266",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.48633 12.4766H14.4658",
    stroke: "#344266",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaycheckIcon);
export default __webpack_public_path__ + "static/media/PaycheckIcon.f47f2b3e904b79222305f66cdf98c97b.svg";
export { ForwardRef as ReactComponent };